// @flow

import type {
  AuthState,
  LoginOperation,
  LoginOperator,
} from '../../types'

// Login Operator
import createLoginOperator from 'hfty-auth/src/loginOperator'

// Module Export Type
type LoginReducers = { [string]: (state: AuthState, payload: LoginOperation) => AuthState }

// Reducers
function cancelOperation (state: AuthState): AuthState {
  return {
    ...state,
    loginOperation: null,
  }
}

function addLoginOperation (state: AuthState, payload: LoginOperation): AuthState {
  return {
    ...state,
    loginOperation: payload,
  }
}

function updateOperation (state: AuthState, payload: LoginOperation): AuthState {
  if (state.loginOperation) {
    return {
      ...state,
      loginOperation: {
        ...payload,
        model: {
          ...state.loginOperation.model,
          ...payload.model,
        },
      },
    }
  } else {
    return {
      ...state,
      loginOperation: payload,
    }
  }
}

export default function composeLoginReducer (): LoginReducers {
  const loginOperator: LoginOperator = createLoginOperator()

  return {
    [loginOperator.actionTypes.add()]: addLoginOperation,
    [loginOperator.actionTypes.updateOperation()]: updateOperation,
    [loginOperator.actionTypes.cancelOperation()]: cancelOperation,
  }
}
